import React from 'react';
import { Grid } from '@mui/material';

import {
  NotificationSettingsItem,
  useDeleteUserNotificationsChannelMutation,
  useDeleteUserNotificationsPreferenceMutation,
  useUpdateUserNotificationsChannelMutation,
  useUpdateUserNotificationsPreferenceMutation,
} from 'store/apis/notifications';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { SectionTitle } from './section-title';
import { Option } from './option';

export interface OptionsGroupProps {
  title: string;
  options: NotificationSettingsItem[];
  isCompact?: boolean;
  userId?: number;
}

export const OptionsGroup = ({ title, options, userId, isCompact = false }: OptionsGroupProps) => {
  const { orgSlug, id } = useAppSelector(selectCurrentUserInfo);
  const [enableNotifications] = useUpdateUserNotificationsPreferenceMutation();
  const [disableNotifications] = useDeleteUserNotificationsPreferenceMutation();
  const [enableNotificationChannel] = useUpdateUserNotificationsChannelMutation();
  const [disableNotificationChannel] = useDeleteUserNotificationsChannelMutation();
  const resolvedUserId = userId || id;

  return options.length > 0 ? (
    <>
      <SectionTitle title={title} isCompact={isCompact} />

      <Grid container spacing={3}>
        {options.map(({ id: preference, label, help, enabled, email, sms }, index) => (
          <Grid item xs={12} key={`operational-notification-${index}-settings`}>
            <Option
              title={label}
              subtitle={help}
              checked={enabled}
              email={email}
              sms={sms}
              onOption={() => {
                const mutate = enabled ? disableNotifications : enableNotifications;

                mutate({ orgSlug, userId: resolvedUserId, preference });
              }}
              onChannel={({ channel }) => {
                const mutate =
                  (channel === 'email' && email) || (channel === 'sms' && sms)
                    ? disableNotificationChannel
                    : enableNotificationChannel;

                mutate({ orgSlug, userId: resolvedUserId, preference, channel });
              }}
            />
          </Grid>
        ))}
      </Grid>
    </>
  ) : null;
};
